/*jshint esversion: 6*/
import 'es6-promise/auto';
import Raven from 'raven-js';
import '../../css/share.css';
import '../../css/mi-detail.css';
import '../../css/feedback.css';
import miDetail from './mi-detail';
import xiangkanDetail from './xiangkan-detail';
import {
    Utils__isMiuiBrowser,
    Utils__checkErrorPage,
    Utils__parseQuery,
    Utils__getQueryString,
    Utils__ready,
    Utils__elk404,
    Utils__isMiuiQuickSearchBox,
    Utils__isXiangkan,
    Utils__elkLog,
    Utils__notifyClientArticleNotFound,
} from './utils';
import stats__send from './stats';
import initFmonitor from './fmonitor';
import { getTagsContext, getUserContext } from './sentry';

const UA = navigator.userAgent || '';
let renderDone = xiangkanDetail;

// sentry 监控
function sentryInit(onlineUrl, stagingUrl, isMIUIBrowser) {
  // https://docs.sentry.io/clients/javascript/config/
  const whitelistUrls = [
    /feed\.browser\.miui\.com/,
    /ssl-cdn\.static\.browser\.mi-img\.com/
  ];

  if (process.env.npm_config_file === 'test') {
    Raven.config(stagingUrl, {
      release: __sentryRelease__,
      whitelistUrls,
    }).install();

    Raven.setTagsContext(getTagsContext());
    Raven.setUserContext(getUserContext());
  }

  if (process.env.npm_config_file === 'online') {
    // if (isMIUIBrowser) {
    //   Raven.config(onlineUrl, {
    //     release: __sentryRelease__,
    //     whitelistUrls,
    //   }).install();
    // } else {
    //   Raven.config(onlineUrl, {
    //     release: __sentryRelease__,
    //   }).install();
    // }

    Raven.config(onlineUrl, {
      release: __sentryRelease__,
      whitelistUrls,
    }).install();

    Raven.setTagsContext(getTagsContext());
    Raven.setUserContext(getUserContext());
  }
}

// 小米浏览器内打开
if (Utils__isMiuiBrowser(UA)) {
  // feed-sdk-MIUIBrowser
  sentryInit(
    'https://46e8f0b27e37449d9c87aa386ad47e17@sentry.pay.xiaomi.com/34',
    'https://e8faffa1907c466fb61b5af6f876fe57@sentry.pay.xiaomi.com/33',
    true,
  );
  miDetail(true);
  renderDone = miDetail;

  if (process.env.npm_config_file === 'online') {
    initFmonitor('46e8f0b27e37449d9c87aa386ad47e17', 'feed-sdk-MIUIBrowser', {
      siteSpeedSampleRate: 1,
      expires: 6 * 60 * 60 * 1000, // 6 小时方便回滚 // 1 * 24 * 60 * 60 * 1000,
    });
    Utils__elk404('46e8f0b27e37449d9c87aa386ad47e17', 'feed-sdk-MIUIBrowser');
  }

  if (process.env.npm_config_file === 'test') {
    initFmonitor('e8faffa1907c466fb61b5af6f876fe57', 'feed-sdk-MIUIBrowser-staging');
    Utils__elk404('e8faffa1907c466fb61b5af6f876fe57', 'feed-sdk-MIUIBrowser-staging');
  }
} else {
  // feed-sdk
  sentryInit(
    'https://4727cc752ff34ce796e25aa7cdafb8bf@sentry.pay.xiaomi.com/26',
    'https://dd46fbc9290541b38b1b13849431c3dd@sentry.pay.xiaomi.com/29',
    false,
  );
  // 全局搜索、想看资讯不用初始化
  if (!Utils__isMiuiQuickSearchBox() && !Utils__isXiangkan(UA)) {
    xiangkanDetail(true);
  }

  if (process.env.npm_config_file === 'online') {
    initFmonitor('4727cc752ff34ce796e25aa7cdafb8bf', 'feed-sdk');
    Utils__elk404('4727cc752ff34ce796e25aa7cdafb8bf', 'feed-sdk');

  }

  if (process.env.npm_config_file === 'test') {
    initFmonitor('dd46fbc9290541b38b1b13849431c3dd', 'feed-sdk-staging');
    Utils__elk404('dd46fbc9290541b38b1b13849431c3dd', 'feed-sdk-staging');
  }
}

Utils__ready(function() {
    var state = Utils__parseQuery(Utils__getQueryString());

    Utils__checkErrorPage(function(){
        stats__send({
            name: '文章详情页',
            cate: '死链上报',
            action: '曝光',
            path: state.cateCode,
            ext: JSON.stringify({
                url: location.href,
                cp: state.cp
            })
        });

        // 通知客户端 内容页404
        if (Utils__isMiuiBrowser(UA)) {
            Utils__notifyClientArticleNotFound();
        }
    });

    if (!state.docid || !state.cp) {
      var url = location.href;

      if (url.indexOf('error.html') > -1) {
        return;
      }

      Utils__elkLog({
        key: 'feedsdk__第三方url缺失字段',
        value: {
          href: url,
          referrer: window.document.referrer,
        }
      });
    }
});

// 防止第三方没有 try...catch... 调用 window.miui.openAtlasMode
if (window.miui && typeof window.miui.openAtlasMode !== 'function') {
  window.miui.openAtlasMode = function() {};
}

if (!window.miui) {
  window.miui = {
    openAtlasMode: function() {}
  };
}

window.miui.renderDone = renderDone;

function detailStatusStats() {
    const state = Utils__parseQuery(Utils__getQueryString());
    const matchs = window.navigator.userAgent.match(/(XiaoMi\/.*)$/gi) || [];
    const app = (matchs[0] || 'Unknown').replace(/\d*\.*\s*/g, '');

    // v1、v2 版本详情页占比统计和使用方客户端 UA 统计
    stats__send({
        name: "图文详情页v1、v2版本统计",
        cate: "1",
        action: "曝光",
        path: app,
        ext: JSON.stringify({
            cp: state.cp,
            docid: window.location.hostname
        })
    });
}

detailStatusStats();
